exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".my-schedule-widget {\n  display: block;\n  border: 1px solid #CCCCCC;\n  min-height: unset;\n  background-color: white;\n  border-radius: 5px;\n  box-shadow: 0 0 0 8px #F2F2F2; }\n  .my-schedule-widget h3 {\n    margin-left: 20px; }\n\n.calendar-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 11px;\n  border: 1px solid lightgrey;\n  padding: 10px 0; }\n  .calendar-header button {\n    margin: 0 20px;\n    border: none;\n    background: transparent; }\n\n.today-label {\n  width: fit-content;\n  margin: 0 auto;\n  font-size: 11px; }\n\n.individual-meeting {\n  background-color: rgba(32, 144, 127, 0.6); }\n\n.no-events {\n  margin-left: 20px; }\n\n.date-label {\n  font-weight: bold; }\n\n.meeting-holder {\n  min-height: 30px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/scheduler/mySchedule/mySchedule.scss
// module id = 1413
// module chunks = 0